(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-focus-swiper"] && !Shopify.designMode) return;
  try {
    
  class YGFocusSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiperImage = null;
      this.swiperText = null;
    }

    get getSwiperImage() {
      if (!this.swiperImage) {
        const imageSwiperEl = this.querySelector('.yg-focus-swiper.swiper');
        if (imageSwiperEl) {
          this.swiperImage = new Swiper(imageSwiperEl, {
            // normalizeSlideIndex: false,
            slidesPerView: 1,
            spaceBetween: 40,
          });
        }
      }
      return this.swiperImage;
    }

    get getSwiperText() {
      if (!this.swiperText) {
        const textSwiperEl = this.querySelector('.yg-focus-swiper-text.swiper');
        if (textSwiperEl) {
          this.swiperText = new Swiper(textSwiperEl, {
            slidesPerView: 1,
            navigation: {
              nextEl: textSwiperEl.querySelector('.swiper-button-next'),
              prevEl: textSwiperEl.querySelector('.swiper-button-prev'),
            },
          });
        }
      }
      return this.swiperText;
    }

    connectedCallback() {
      this.swiperImage = this.getSwiperImage;
      this.swiperText = this.getSwiperText;

      this.swiperImage.controller.control = this.swiperText;
      this.swiperText.controller.control = this.swiperImage;
    }
  }

  if (typeof customElements.get('yg-focus-swiper') === 'undefined') {
    customElements.define('yg-focus-swiper', YGFocusSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-gallery-item"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGGallerySlide extends HTMLElement {
      constructor() {
        super();
        this.handleResize = this.handleResize.bind(this);
        this.handleItemHover = this.handleItemHover.bind(this);
        this.currentActiveItem = null;
      }

      get items() {
        return this.querySelectorAll('.yg-gallery-item');
      }

      connectedCallback() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        this.removeHoverListeners();
        this.removeClickListeners();
      }

      handleResize() {
        const width = window.innerWidth;
        if (width >= 700) {
          this.addHoverListeners();
          this.removeClickListeners();
        } else {
          this.removeHoverListeners();
          this.addClickListeners();
        }
      }

      addHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.addEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
          item.addEventListener('mouseleave', this.handleItemHover);
        });
      }

      removeHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
        });
      }

      addClickListeners() {
        this.handleItemClick = this.handleItemClick.bind(this);
        this.items.forEach((item) => {
          item.removeEventListener('click', this.handleItemClick);
          item.addEventListener('click', this.handleItemClick);
        });
      }

      removeClickListeners() {
        if (this.handleItemClick) {
          this.items.forEach((item) => {
            item.removeEventListener('click', this.handleItemClick);
          });
        }
      }

      handleItemClick(e) {
        const target = e.currentTarget;
        this.items.forEach((item) => item.classList.remove('active'));
        target.classList.add('active');
        this.currentActiveItem = target;
      }

      handleItemHover(e) {
        const type = e.type;
        const target = e.currentTarget;

        if (type === 'mouseenter') {
          this.items.forEach((item) => item.classList.remove('active'));
          target.classList.add('active');
          this.currentActiveItem = target;
        } else if (type === 'mouseleave') {
          setTimeout(() => {
            const hoverItem = [...this.items].find((item) => item.matches(':hover'));
            if (!hoverItem && this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
            }
          }, 10);
        }
      }
    }

    if (!window.customElements.get('yg-gallery-slide')) {
      window.customElements.define('yg-gallery-slide', YGGallerySlide);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-hover-tabs"] && !Shopify.designMode) return;
  try {
    
  if (typeof customElements.get('yg-hover-tabs') === 'undefined') {
    class YGHoverTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.tabs = this.querySelectorAll('.yg-hover-tabs-tab');
        this.contents = this.querySelectorAll('.yg-hover-tabs-image-wrap');
        
        this.initHeight();
        window.addEventListener('resize', () => this.initHeight());
        // 监听 tab 的 hover/click 事件
        this.tabs.forEach((tab, idx) => {
          tab.addEventListener('mouseenter', () => {
            this.activateTab(idx);
          });
          tab.addEventListener('click', () => {
            this.activateTab(idx);
          });
        });
      }

      // 切换函数，激活时先去除所有元素的active类名，然后给当前元素添加active类名
      activateTab(index) {
        // 如果当前已经是激活状态，则不做任何操作
        if (this.tabs[index] && this.tabs[index].classList.contains('active')) {
          return;
        }

        this.tabs.forEach(tab => tab.classList.remove('active'));
        this.contents.forEach(content => content.classList.remove('active'));
        if(this.tabs[index]) this.tabs[index].classList.add('active');
        if(this.contents[index]) this.contents[index].classList.add('active');
      }

      initHeight() {
        // 获取所有描述元素
        const descriptions = this.querySelectorAll('.yg-hover-tabs-tab-description');
        let maxHeights = [];

        descriptions.forEach(desc => {
          // 先重置height以取到原始高度
          desc.style.height = 'auto';
          const height = desc.scrollHeight;
          maxHeights.push(height);
          desc.style.removeProperty('height');
        });

        // 分别设置每个描述元素的自定义属性 --max-height
        descriptions.forEach((desc, idx) => {
          desc.style.setProperty('--max-height', `${maxHeights[idx]}px`);
        });
      }
    }
    customElements.define('yg-hover-tabs', YGHoverTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-icon-list"] && !Shopify.designMode) return;
  try {
    
  class YgIconList extends HTMLElement {
    connectedCallback() {
      // CSS animation handles the carousel automatically
    }
  }
  if (!customElements.get('yg-icon-list')) {
    customElements.define('yg-icon-list', YgIconList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-icon-swiper"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  class YgIconWithText extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {

      this.swiper = new Swiper(this, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        breakpoints: {
          750: {
            slidesPerView: 1.2,
            spaceBetween: 12,
          },
          1150: {
            slidesPerView: 4.2,
            spaceBetween: 20,
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }
  }

  if (!customElements.get('yg-icon-with-text')) {
    customElements.define('yg-icon-with-text', YgIconWithText);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-icon-with-text"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  class YgIconWithText extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {

      this.swiper = new Swiper(this, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        breakpoints: {
          750: {
            slidesPerView: 1.2,
            spaceBetween: 12,
          },
          1150: {
            slidesPerView: 4.2,
            spaceBetween: 20,
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }
  }

  if (!customElements.get('yg-icon-with-text')) {
    customElements.define('yg-icon-with-text', YgIconWithText);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-swiper"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  class YGImageSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {

      this.swiper = new Swiper(this, {
        slidesPerView: 1.15,
        spaceBetween: 12,
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 12,
          },
          1150: {
            slidesPerView: 3.8,
            spaceBetween: 20,
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }
  }

  if (!customElements.get('yg-image-swiper')) {
    customElements.define('yg-image-swiper', YGImageSwiper);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-scroll-image"] && !Shopify.designMode) return;
  try {
    
    class YGScrollImage extends HTMLElement {
    constructor() {
        super();
        this._init();
    }

    _init() {
        const sectionId = this.getAttribute("data-section-id");
        if (!sectionId) return;

        // 等待图片加载完成后再计算
        this._waitForImages().then(() => {
        this._calculateAnimation();
        });

        // 监听窗口大小变化
        if (window.ResizeObserver) {
        new ResizeObserver(() => {
            this._calculateAnimation();
        }).observe(this);
        }

        // 鼠标悬停暂停/恢复
        const container = document.getElementById(`yg-scrolling-container-${sectionId}`);
        if (container) {
        container.addEventListener('mouseenter', () => this._pauseScrolling());
        container.addEventListener('mouseleave', () => this._resumeScrolling());
        }
    }

    _waitForImages() {
        return new Promise((resolve) => {
        const images = this.querySelectorAll('yg-image img, yg-image svg');
        if (images.length === 0) {
            resolve();
            return;
        }

        let loadedCount = 0;
        const totalImages = images.length;

        const checkComplete = () => {
            loadedCount++;
            if (loadedCount >= totalImages) {
            // 额外等待一小段时间确保布局稳定
            setTimeout(resolve, 100);
            }
        };

        images.forEach((img) => {
            if (img.complete) {
            checkComplete();
            } else {
            img.addEventListener('load', checkComplete, { once: true });
            img.addEventListener('error', checkComplete, { once: true });
            }
        });
        });
    }

    _calculateAnimation() {
        const scrollingSpeed = parseFloat(this.getAttribute("scrolling-speed") || 45);
        const sectionId = this.getAttribute("data-section-id");
        
        // 获取第一个滚动元素的宽度
        const firstElement = this;
        const elementWidth = firstElement.offsetWidth;
        
        if (elementWidth === 0) {
        // 如果宽度为0，延迟重试
        setTimeout(() => this._calculateAnimation(), 100);
        return;
        }

        // 获取两个元素之间的 gap（从父元素获取）
        const listElement = document.getElementById(`yg-scrolling-list-${sectionId}`);
        const computedStyle = window.getComputedStyle(listElement);
        const gap = parseFloat(computedStyle.gap) || 0;
        
        // 动画移动的距离 = 元素宽度 + gap（这样第二个元素才能无缝接上）
        const moveDistance = elementWidth + gap;

        // 计算动画时长：速度越大，移动越快（时长越短）
        // scrollingSpeed 表示每秒移动的像素数
        const duration = moveDistance / scrollingSpeed;

        // 设置CSS变量
        this.style.setProperty('--marquee-width', `${moveDistance}px`);
        this.style.setProperty('--marquee-duration', `${duration}s`);

        // 确保所有元素使用相同的动画参数
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((el) => {
        if (el !== this) {
            el.style.setProperty('--marquee-width', `${moveDistance}px`);
            el.style.setProperty('--marquee-duration', `${duration}s`);
        }
        });
    }

    _pauseScrolling() {
        const sectionId = this.getAttribute("data-section-id");
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((item) => {
        item.style.animationPlayState = 'paused';
        });
    }

    _resumeScrolling() {
        const sectionId = this.getAttribute("data-section-id");
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((item) => {
        item.style.animationPlayState = 'running';
        });
    }
    }

    if (!window.customElements.get("yg-scroll-image")) {
    window.customElements.define("yg-scroll-image", YGScrollImage);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-time"] && !Shopify.designMode) return;
  try {
    
    class YGTime extends HTMLElement { 
        constructor() {
            super();
            this.initSwiper();
        }
        initSwiper() { 
            const thumb = new Swiper(this.querySelector('.yg-right-image'), {
                slidesPerView: 1,
                spaceBetween: 10,
            });
            
            const paginationEl = this.querySelector('.swiper-pagination');
            const main = new Swiper(this.querySelector('.yg-left-content'), {
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: {
                    nextEl: this.querySelector('.yg-swiper-button-next'),
                    prevEl: this.querySelector('.yg-swiper-button-prev'),
                },
                pagination: {
                    el: paginationEl,
                    clickable: true,
                    renderBullet: function (index, className) {
                        // 自定义 bullet 结构，嵌套进度条 div
                        return '<span class="' + className + '"><div class="yg-progress-bar"></div></span>';
                    },
                },
                thumbs: {
                    swiper: thumb,
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                }
            });

            thumb.on('slideChange', function () { 
                main.slideTo(thumb.realIndex);
            });

            // 动态设置 grid-template-columns 基于 bullet 数量
            const bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
            if (bullets.length > 0) {
                paginationEl.style.gridTemplateColumns = `repeat(${bullets.length}, 1fr)`;
            }
        }
    }
    customElements.define('yg-time', YGTime);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-switch"] && !Shopify.designMode) return;
  try {
    
  class YGVideoSwitch extends YGUtils {
    constructor() {
      super();
    }

    get initVideoSwiper() {
      if (this.videoSwiper) return this.videoSwiper;

      let videoDom = this.querySelector('.yg-video-list');
      // 先设置默认的slidesPerView属性
      if (!videoDom.hasAttribute('data-slides-per-view')) {
        videoDom.setAttribute('data-slides-per-view', '1');
      }
      const swiper = this.initSwiper(videoDom);
      // 确保slidesPerView设置为1，避免少显示slide
      if (swiper && swiper.params) {
        // 设置默认的slidesPerView
        swiper.params.slidesPerView = 1;
        swiper.params.spaceBetween = 0;
        
        // 确保breakpoints中有默认值（0断点）
        if (swiper.params.breakpoints) {
          // 如果没有0断点，添加一个
          if (!swiper.params.breakpoints[0]) {
            swiper.params.breakpoints[0] = {
              slidesPerView: 1,
              spaceBetween: 0
            };
          }
        } else {
          // 如果没有breakpoints，创建一个
          swiper.params.breakpoints = {
            0: {
              slidesPerView: 1,
              spaceBetween: 0
            },
            260: {
              slidesPerView: 1,
              spaceBetween: 20
            }
          };
        }
        swiper.update();
      }
      return swiper;
    }

    get initTextSwiper() {
      if (this.textSwiper) return this.textSwiper;

      let textDom = this.querySelector('.yg-text-list');
      // 先设置默认的slidesPerView属性
      if (!textDom.hasAttribute('data-slides-per-view')) {
        textDom.setAttribute('data-slides-per-view', '1');
      }
      const swiper = this.initSwiper(textDom);
      // 确保slidesPerView设置为1，避免少显示slide
      if (swiper && swiper.params) {
        // 设置默认的slidesPerView
        swiper.params.slidesPerView = 1;
        swiper.params.spaceBetween = 0;
        
        // 确保breakpoints中有默认值（0断点）
        if (swiper.params.breakpoints) {
          // 如果没有0断点，添加一个
          if (!swiper.params.breakpoints[0]) {
            swiper.params.breakpoints[0] = {
              slidesPerView: 1,
              spaceBetween: 0
            };
          }
        } else {
          // 如果没有breakpoints，创建一个
          swiper.params.breakpoints = {
            0: {
              slidesPerView: 1,
              spaceBetween: 0
            },
            260: {
              slidesPerView: 1,
              spaceBetween: 20
            }
          };
        }
        swiper.update();
      }
      return swiper;
    }

    connectedCallback() {
      setTimeout(() => {
        // 初始化Intersection Observer
        this.initIntersectionObserver();

        this.textSwiper = this.initTextSwiper;
        this.videoSwiper = this.initVideoSwiper;
        this.progressBar = this.querySelector('.yg-progress-bar');
        this.videoList = this.querySelectorAll('video');
        this.animating = false;

        if (this.videoSwiper && this.textSwiper) {
          const videoSlides = this.videoSwiper.slides.length;
          const textSlides = this.textSwiper.slides.length;
          console.log(`Video slides: ${videoSlides}, Text slides: ${textSlides}`);
          
          if (videoSlides !== textSlides) {
            console.warn(`Swiper slide count mismatch: video=${videoSlides}, text=${textSlides}`);
          }
          
          this._syncing = false; 
          
          this.textSwiper.on('slideChangeTransitionEnd', () => {
            if (this._syncing) return;
            if (this.videoSwiper && this.textSwiper && this.videoSwiper.activeIndex !== this.textSwiper.activeIndex) {
              this._syncing = true;
              this.videoSwiper.slideTo(this.textSwiper.activeIndex);
              setTimeout(() => {
                this._syncing = false;
              }, 50);
            }
          });
          
          this.videoSwiper.on('slideChangeTransitionEnd', () => {
            if (this._syncing) return;
            if (this.videoSwiper && this.textSwiper && this.textSwiper.activeIndex !== this.videoSwiper.activeIndex) {
              this._syncing = true;
              this.textSwiper.slideTo(this.videoSwiper.activeIndex);
              setTimeout(() => {
                this._syncing = false;
              }, 50);
            }
          });
        }
        
        this.autoplay = this.getAttribute('data-autoplay') === 'true';
        this.imageDuration =
          parseFloat(this.getAttribute('data-image-duration')) > 0
            ? parseFloat(this.getAttribute('data-image-duration'))
            : 5;

        this.currentImageStart = null;
        this.currentImageDuration = null;
        
        this.slideChangeTransitionEnd();
        
        if (this.videoSwiper && this._slideChangeHandler) {
          this._slideChangeHandler();
        }
      }, 100);

    }

    disconnectedCallback() {
      // 组件销毁时停止观察
      if (this.observer) {
        this.observer.disconnect();
      }
    }


    initIntersectionObserver() {
      // 创建Intersection Observer实例
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 当组件进入视口时，如果有视频则播放
            const activeSlide = this.videoSwiper ? this.videoSwiper.slides[this.videoSwiper.activeIndex] : null;
            if (activeSlide) {
              const video = activeSlide.querySelector('video');
              if (video && this.autoplay) {
                video.play().catch(() => {});
              } else if (!video && this.autoplay && this.imageDuration > 0) {
                // 如果是图片幻灯片，开始图片轮播计时
                this.currentVideo = null;
                this.currentImageStart = performance.now();
                this.currentImageDuration = this.imageDuration * 1000;
                this.animating = true;
                
                if (this.progressBar) {
                  this.progressBar.style.width = '0%';
                }
                
                this.updateProgress();
              }
            }
          } else {
            // 当组件离开视口时，暂停所有视频并停止图片轮播计时
            this.videoList.forEach(video => {
              video.pause();
              video.currentTime = 0;
            });
            
            // 停止图片轮播计时
            this.currentVideo = null;
            this.currentImageStart = null;
            this.currentImageDuration = null;
            this.animating = false;
            
            if (this.progressBar) {
              this.progressBar.style.width = '0%';
            }
          }
        });
      }, {
        threshold: 0.3 // 当组件的30%进入视口时触发
      });
      
      // 开始观察当前元素
      this.observer.observe(this);
    }



    slideChangeTransitionEnd() {
      if (this.videoSwiper) {
        if (this._slideChangeHandler) {
          this.videoSwiper.off('slideChangeTransitionEnd', this._slideChangeHandler);
        }
        
        this._slideChangeHandler = () => {
          const slides = this.videoSwiper.slides;
          const activeIndex = this.videoSwiper.activeIndex;
          const activeSlide = slides[activeIndex];

          this.animating = false;
          this.currentVideo = null;
          this.currentImageStart = null;
          this.currentImageDuration = null;
          if (this.progressBar) {
            this.progressBar.style.width = '0%';
          }
          
          requestAnimationFrame(() => {
            this.handleSlideChange(activeSlide, activeIndex, slides);
          });
        };
        
        this.handleSlideChange = (activeSlide, activeIndex, slides) => {

          slides.forEach((slide, index) => {
            if (index === activeIndex) return;
            const video = slide.querySelector('video');
            if (video) {
              video.pause();
              video.currentTime = 0;
            }
          });
          
          if (activeSlide) {
            const video = activeSlide.querySelector('video');

            if (video) {
              const oldVideo = this.currentVideo;
              if (oldVideo && oldVideo !== video && this._videoPlayHandler) {
                oldVideo.removeEventListener('play', this._videoPlayHandler);
                oldVideo.removeEventListener('pause', this._videoPauseHandler);
                oldVideo.removeEventListener('ended', this._videoEndHandler);
              }
              
              if (this._videoPlayHandler) {
                video.removeEventListener('play', this._videoPlayHandler);
                video.removeEventListener('pause', this._videoPauseHandler);
                video.removeEventListener('ended', this._videoEndHandler);
              }
              
              this._videoPlayHandler = () => {
                this.currentVideo = video;
                this.currentImageStart = null;
                this.currentImageDuration = null;
                this.animating = true;
                this.updateProgress();
              };
              
              this._videoPauseHandler = () => {
                this.animating = false;
              };
              
              this._videoEndHandler = () => {
                this.animating = false;
                if (this.autoplay && this.videoSwiper.activeIndex < this.videoSwiper.slides.length - 1) {
                  this.videoSwiper.slideNext();
                }
              };
              
              video.addEventListener('play', this._videoPlayHandler);
              video.addEventListener('pause', this._videoPauseHandler);
              video.addEventListener('ended', this._videoEndHandler);
              
              if (this.autoplay) {
                video.play().catch(() => {
                });
                if (!video.paused) {
                  this.currentVideo = video;
                  this.currentImageStart = null;
                  this.currentImageDuration = null;
                  this.animating = true;
                  this.updateProgress();
                }
              }
            } else {
              if (this.autoplay && this.imageDuration > 0) {
                this.currentVideo = null;
                this.currentImageStart = performance.now();
                this.currentImageDuration = this.imageDuration * 1000;
                this.animating = true;
                
                if (this.progressBar) {
                  this.progressBar.style.width = '0%';
                }
                
                this.updateProgress();
              }
            }
          }
        };
        
        this.videoSwiper.on('slideChangeTransitionEnd', this._slideChangeHandler);
      }
    }

    updateProgress() {
      if (!this.currentVideo && !this.currentImageStart) return;

      let percent = 0;
      let shouldContinue = true;

      if (this.currentVideo) {
        if (!this.currentVideo.duration || isNaN(this.currentVideo.duration)) {
          percent = 0;
        } else {
          percent = (this.currentVideo.currentTime / this.currentVideo.duration) * 100;
        }
      } else if (this.currentImageStart && this.currentImageDuration) {
        const elapsed = performance.now() - this.currentImageStart;
        percent = Math.min((elapsed / this.currentImageDuration) * 100, 100);

        if (elapsed >= this.currentImageDuration) {
          percent = 100;
          shouldContinue = false;
          this.currentImageStart = null;
          this.currentImageDuration = null;
          if (this.progressBar) {
            this.progressBar.style.width = '100%';
          }
          if (this.autoplay && this.videoSwiper && this.videoSwiper.activeIndex < this.videoSwiper.slides.length - 1) {
            this.videoSwiper.slideNext();
          }
          return;
        }
      }

      if (this.progressBar) {
        this.progressBar.style.width = percent + '%';
      }

      if (shouldContinue && (this.currentVideo || this.currentImageStart)) {
        requestAnimationFrame(() => this.updateProgress());
      }
    }
  }
  if (!customElements.get('yg-video-switch')) {
    customElements.define('yg-video-switch', YGVideoSwitch);
  }

  } catch(e) { console.error(e); }
})();
})();
